import css from 'styled-jsx/css'
import { colors } from '../../styles'

const menuItemStyles = `
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${colors.primaryText};
  width: 192px;
`

export const DropdownMenuStyles = css`
.DropdownMenu {
  border-radius: 8px;
  background: none;
  overflow: hidden;
  height: 40px;
  //box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
}

.DropdownMenu.active,
.DropdownMenu.sortMenu.active {
  border: none;
  box-shadow: inset 0px 0px 2px #000000;
}

.DropdownMenu.active .title {
  border: 2px solid transparent;
}

.DropdownMenu.active .title:hover {
  border-color: transparent;
}

.DropdownMenu.tv-guide {
  width: auto;
  height: 32px !important;
  overflow: hidden !important;
  border-radius: 4px;
  background: ${colors.elevatedBg};
}
.menu {
  position: absolute;
  z-index: 3;
  padding: 8px;
  margin: 0;
  background: rgba(21, 21, 21, 0.75);
  backdrop-filter: blur(40px);
  display: none;
  border-radius: 8px;
  flex-direction: row;
  gap: 4px;
}

:global(.menu-column) {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.menu.tv-guide {
  background: ${colors.elevatedBg};
  border: 1px solid ${colors.ctvBg};
  backdrop-filter: unset;
  top: auto;
  max-height: 150px;
  overflow-y: auto;
  width: 230px !important;
  z-index: 5;
  font-family: Source Sans Pro;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: ${colors.primaryText};
}

.menu.tv-guide .menu-column {
  width: 100%;
}

.menu.live-page {
  background: ${colors.elevatedBg};
  border: 1px solid ${colors.ctvBg};
  backdrop-filter: unset;
  top: auto;
  height: auto !important;
  width: auto !important;
  z-index: 5;
  font-family: Source Sans Pro;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: ${colors.primaryText};
}

.menu.active {
  display: flex;
}

.title {
  display: block;
  height: 40px;
  text-transform: capitalize;
  ${menuItemStyles};
  cursor: pointer;
  border-radius: 8px;
  background: ${colors.categoriesDarkPurple};
  text-align: center;
  color: ${colors.categoriesPurple};
  width: fit-content;
  box-sizing: border-box;
  border: 2px solid transparent;
}

.title.tv-guide {
  background: ${colors.elevatedBg};
  font-family: Source Sans Pro;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  width: 100%;
  color: ${colors.primaryText};
  justify-content: space-between;
}

.wrapper.tv-guide {
  width: 100%;
}

.innerTitle {
  display: inherit;
  margin: 8px 8px 8px 16px;
  line-height: 20.11px;
  width: 100%;
  justify-content: space-between;
}

.sortMenu .title .innerTitle {
  margin: 8px 13px;
}

.title h4 {
  color: ${colors.categoriesPurple};
}

.title:hover {
  border-color: ${colors.categoriesPurple};
}

.title.tv-guide h4 {
  color: unset;
}

.title.tv-guide:hover {
  border: unset;
}
.sortMenu .title:hover {
  border-color: ${colors.primaryText};
}

.sortMenu .title {
  background: ${colors.ctvBg};
  color: ${colors.primaryText};
}

.sortMenu .title h4 {
  color: ${colors.primaryText};
}

.active .title, .active .title h4 {
  color: ${colors.tertiaryText};
}

.active .title {
  background: ${colors.elevatedBg};
}

.DropdownMenu .button {

}

.DropdownMenu.active .button {
  color: ${colors.tertiaryText};
}

.chevron-icon {
  display: inline-block;
  transition: transform .2s ease-in;
  width: 24px;
  height: 24px;
}

.sort-icon {
  width: 24px;
  height: 24px;
  align-items: center;
  display: flex;
  margin-right: 4px;
}

.chevron-icon.is-expanded {
  transform: rotate(180deg)
}

.menu {
    margin-top: 2px;
}

.menu.sortMenu {
  position: absolute;
  right: 48px;
}

.overlay-header {
  display: none;
  padding: 57.5px 16px 23px 16px;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: ${colors.primaryText}
}

.overlay-header h3 {
  white-space: nowrap;
  width: fit-content;
  display: flex;
  align-items: center;
}

.overlay-header span {
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  text-align: end;
}

.overlayCloseButton {
  width: 43px;
  height: 43px;
}
@media (max-width: 1024px) {
  .DropdownMenuItem.categories{
    color: ${colors.secondaryText};
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    width: 192px;
  }

  .DropdownMenuItem.categories.active {
    color: ${colors.textInput};
  }

  .menu.categories:not(.sortMenu), .menu.categories.sortMenu {
    top: -13px;
    left: 0;
    right: 0;
    bottom: 0;
    height: auto;
    overflow-y: scroll;
    position: fixed;
    width: 100vw !important;
    z-index: 5;
    flex-direction: column;
  }

  .menu.categories:not(.sortMenu) {
    height: 100% !important;
    top: -1px;
    background: rgba(21, 21, 21, 0.75);
    backdrop-filter: blur(40px);
    padding-bottom: 100px;
    border-radius: 0px;
    border: none;
  }
  .menu-column {
    width: 100%;
  }

  .menu-column:last-child {
    padding-bottom: 100px;
  }

  .overlay-header.categories{
    display: flex;
  }

}

@media (max-width: 1627px) {
  .menu.sortMenu {
    right: 32px;
  }
}

@media (max-width: 899px) {
  .sortMenu h4 {
    display: none;
  }

  .sort-icon {
    margin-right: 0;
    width: 100%;
  }

  .sortMenu .title .innerTitle {
    margin: 13px 13px 13px 13px;
  }
}

@media (max-width: 767px) {
  .DropdownMenuItem {
    color: ${colors.secondaryText};
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    width: 192px;
  }

  .DropdownMenuItem.active {
    color: ${colors.textInput};
  }

  .menu.tv-guide {
    max-height: 120vh !important;
    background: rgba(21, 21, 21, 0.75);
    height: 120vh !important;
    backdrop-filter: blur(40px);
  }

  .menu.tv-guide .menu-column {
    width: 100%;
  }

  .DropdownMenu.tv-guide {
    width: 100%;
    height: 32px !important;
  }

  .menu:not(.sortMenu), .menu.sortMenu {
    top: -13px;
    left: 0;
    right: 0;
    bottom: 0;
    height: auto;
    overflow-y: scroll;
    position: fixed;
    width: 100vw !important;
    z-index: 5;
    flex-direction: column;
  }

  .menu:not(.sortMenu) {
    height: 100% !important;
    top: -1px;
    background: rgba(21, 21, 21, 0.75);
    backdrop-filter: blur(40px);
    padding-bottom: 100px;
    border-radius: 0px;
    border: none;
  }

  .menu-column {
    width: 100%;
  }

  .menu-column:last-child {
    padding-bottom: 100px;
  }

  .overlay-header {
    display: flex;
  }
}
`

export const DropdownMenuItemStyles = css`
  .menu-link {
    font-size: 16px;
    font-weight: 400;
    line-height: 20.11px;
    color: ${colors.primaryText};
    padding: 0 12px;
    border-radius: 8px;
    height: 35px;
    display: flex;
    align-items: center;
  }

  .DropdownMenuItem {
    order: 2;
    width: 192px;
    border-radius: 8px;
    margin: 2px 0;
  }

  .DropdownMenuItem.tv-guide {
    width: 100%;
  }

  .DropdownMenuItem:hover {
    background: ${colors.textInput};
  }

  .DropdownMenuItem.active.order-top {
    order: 1;
  }

  .DropdownMenuItem.active {
    background: ${colors.textInput};
  }



  .active {
    pointer-events: none;
  }

  @media (max-width: 767px) {
    .menu-link {
      color: ${colors.secondaryText};
    }

    .active .menu-link {
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: ${colors.primaryText};
    }

    .DropdownMenuItem.active {
      background: unset;
    }


    .DropdownMenuItem {
      width: fit-content;
    }

    .menu-link {
      height: 50px;
      font-size: 18px;
    }

    .DropdownMenuItem:hover {
      background: unset;
    }

    .DropdownMenuItem .menu-link:hover {
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: ${colors.primaryText};
    }
  }

`
